/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReferentialItemDto } from './ReferentialItemDto';
import {
    ReferentialItemDtoFromJSON,
    ReferentialItemDtoFromJSONTyped,
    ReferentialItemDtoToJSON,
} from './ReferentialItemDto';

/**
 * 
 * @export
 * @interface ReferentialResultInfoDto
 */
export interface ReferentialResultInfoDto {
    /**
     * 
     * @type {Array<ReferentialItemDto>}
     * @memberof ReferentialResultInfoDto
     */
    list?: Array<ReferentialItemDto> | null;
}

/**
 * Check if a given object implements the ReferentialResultInfoDto interface.
 */
export function instanceOfReferentialResultInfoDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReferentialResultInfoDtoFromJSON(json: any): ReferentialResultInfoDto {
    return ReferentialResultInfoDtoFromJSONTyped(json, false);
}

export function ReferentialResultInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferentialResultInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': !exists(json, 'list') ? undefined : (json['list'] === null ? null : (json['list'] as Array<any>).map(ReferentialItemDtoFromJSON)),
    };
}

export function ReferentialResultInfoDtoToJSON(value?: ReferentialResultInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': value.list === undefined ? undefined : (value.list === null ? null : (value.list as Array<any>).map(ReferentialItemDtoToJSON)),
    };
}

